const getDataFieldsCombochart = () => {
  return [
    {
      title: "X-Axis",
      type: "dropzone",
      single: true,
      dataTypeAllowed: "all",
      reduxKey: "groupByFields",
      itemInArray: true,
    },
    {
      title: "Y-Axis",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "number",
      reduxKey: "valueColumns",
      itemInArray: true,
    },

    {
      title: "Filters",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "filters",
      itemInArray: true,
    },
    {
      title: "Tooltip",
      type: "dropzone",
      single: false,
      dataTypeAllowed: "all",
      reduxKey: "tooltip",
      itemInArray: true,
    },
    {
      title: "Row Limit",
      type: "dropdown",
      reduxKey: "rowLimit",
      itemInArray: false,
      defaultValue: 500,
      valueType: "Number",
      canEdit: true,
    },
  ];
};

export { getDataFieldsCombochart };

const getCustomizationCombochart = () => {
  return [
    {
      title: "Color",
      type: "COLOR",
      reduxKey: "colorSchemeid",
      defaultType: "RANDOM",
    },
    {
      title: "Bar Size",
      type: "range",
      defaultValue: "30",
      minValue: 0,
      maxValue: 100,
      reduxKey: "barSize",
      itemInArray: false,
    },
    {
      title: "Point Size",
      type: "range",
      defaultValue: 6,
      minValue: 5,
      maxValue: 20,
      reduxKey: "ComboLinepointSize",
      itemInArray: false,
    },

    //barchart
    {
      title: "Bar Data Labels",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isComboBarLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelComboBarPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "InsideBottom", value: "insideBottom" },
            // { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },

        {
          title: "Font Color",
          type: "fontColor",
          minValue: 0,
          maxValue: 40,
          reduxKey: "labelComboBarFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 15,
          minValue: 12,
          maxValue: 90,
          reduxKey: "labelComboBarFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },

        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelComboBarRotate",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    //line
    {
      title: "Line Data Labels",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isComboLineLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelComboLinePosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "InsideBottom", value: "insideBottom" },
            // { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },

        {
          title: "Font Color",
          type: "fontColor",
          defaultValue: "#0c0d0d",
          minValue: 0,
          maxValue: 40,
          reduxKey: "labelComboLineFontColor",
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 15,
          minValue: 12,
          maxValue: 90,
          reduxKey: "labelComboLineFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelComboLineRotate",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
      ],
    },

    //area chartlabel
    {
      title: "Area Data Labels",
      type: "CONTAINER_WITH_TOGGLE",
      defaultValue: true,
      reduxKey: "isComboAreaLabelVisible",
      innerComponents: [
        {
          title: "Position",
          type: "SELECT_BOX",
          reduxKey: "labelComboAreaPosition",
          options: [
            { label: "Top", value: "top" },
            { label: "Left", value: "left" },
            { label: "Right", value: "right" },
            { label: "InsideBottom", value: "insideBottom" },
            // { label: "Bottom", value: "bottom" },
            { label: "Center", value: "center" },
          ],
          defaultValue: { label: "Top", value: "top" },
          isParent: true,
        },

        {
          title: "Font Color",
          type: "fontColor",
          minValue: 0,
          maxValue: 40,
          reduxKey: "labelComboAreaFontColor",
          parentType: "CONTAINER_WITH_TOGGLE",
          isParent: true,
        },
        {
          title: "Font Size",
          type: "range",
          defaultValue: 15,
          minValue: 12,
          maxValue: 90,
          reduxKey: "labelComboAreaFontSize",
          parentType: "CONTAINER_WITH_TOGGLE",
        },
        {
          title: "Rotate",
          type: "range",
          defaultValue: 0,
          minValue: 0,
          maxValue: 360,
          reduxKey: "labelComboAreaRotate",
          parentType: "CONTAINER_WITH_TOGGLE",
        },
      ],
    },

    // {
    //   title: "Refrence Line",
    //   type: "text",
    //   defaultValue: 0,
    //   reduxKey: "referenceLine",
    // },
    {
      title: "Grid",
      type: "checkbox",
      defaultValue: true,
      reduxKey: "isGridVisible",
    },

    {
      title: "TransPose",
      type: "checkbox",
      defaultValue: false,
      reduxKey: "isTransposeVisible",
    },

    //legend
  ];
};

export { getCustomizationCombochart };
